<div>
    <div style="margin-left: 80%; margin-bottom: 2%;">

        <button type="button" mat-raised-button matTooltip="Download Execelsheet" class="btn btn-danger"
            (click)="exportexcel('Address')" style="margin-top: 2%;">
            Export
        </button>


        <button id="print-button" class="noPrint" style="margin-top: 2%; margin-left: 2%; display: none;"
            mat-raised-button color="primary" printSectionId="print-section" [useExistingCss]="true" ngxPrint>
            Print
        </button>

        <button (click)="print()" class="noPrint" style="margin-top: 2%; margin-left: 2%" mat-raised-button
            color="primary">
            Print
        </button>

        <button class="noPrint" style="margin-top: 2%" mat-button mat-dialog-close>
            Close
        </button>
    </div>

    <div class="container">
        <table class="table table-bordered" id="print-section">
            <thead>
            </thead>
            <hr>
            <tbody>
                <div class="row" style="display: flex; flex-wrap: wrap; margin-left: 12px;margin-top: -22px;">
                    <!-- Loop through all items, but limit 3 per row -->
                    <ng-container *ngFor="let advtGroup of Address; let i = index">
                        <div *ngFor="let data2 of advtGroup" class="col"
                            style="flex: 0 0 33.33%; padding: 10px; box-sizing: border-box; page-break-inside: avoid;font-weight: bold;color: #0a0a0a;">
                            <b style="font-size: 20px;color: #0a0a0a;">{{ data2.name }}</b> <br>
                            <span
                                style="font-size: 18px; color: #0a0a0a;">{{ data2.address }}</span>
                            <br>
                            <span style="font-size: 18px;color: #0a0a0a;">{{ data2.taluka }}</span>
                            <br>
                            <span style="font-size: 18px;color: #0a0a0a;">{{ data2.district }}-{{
                                data2.pincode }} {{ data2.state
                                }}</span> <br>
                            <b style="font-size: 18px;color: #0a0a0a;"> मो.क्र.{{ data2.mobile }}</b>
                        </div>
                    </ng-container>
                </div>
            </tbody>
        </table>
    </div>
</div>